module.exports = __webpack_public_path__ + "static/images/idCardExample-2.48a91cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/autoInsurance/idCardExample-2.png
// module id = 1rrP
// module chunks = 0